import React from "react";

const ProductSliderComponent = (props) => {
  const { Renderer } = props;

  return <Renderer {...props} />;
};

export default ProductSliderComponent;
